import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft } from "lucide-react";
import { useNavigate, Link } from "react-router-dom";
import { PageHead } from "@/components/seo/PageHead";

export default function CasesCreative() {
  const navigate = useNavigate();
  
  const cases = [
    {
      title: "Beauté capillaire — DNVB",
      subtitle: "Repère « cheveux sains »",
      href: "/cas/beaute-capillaire-dnvb",
      badge: "Beauté"
    },
    {
      title: "Food — Export premium",
      subtitle: "Codes internationaux + terroir",
      href: "/cas/food-export-premium",
      badge: "Food"
    },
    {
      title: "Tech logistique — B2B",
      subtitle: "Crédibilité achats",
      href: "/cas/tech-logistique-b2b",
      badge: "Tech"
    }
  ];

  return (
    <>
      <PageHead
        title="Études Creative Strategist — Positionnement & Identité | Cosmos Wave"
        description="Découvrez nos projets créatifs : positionnement marque, identité visuelle, packaging et assets Amazon pour DNVB et marques premium."
        canonical="https://www.cosmos-wave.com/cases/creative"
        pageType="website"
      />
      <div className="min-h-screen bg-background">

      {/* Hero Section */}
      <section className="py-12 lg:py-16 xl:py-20 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-card/10 via-transparent to-card/10" />
        <div className="container mx-auto px-6 xl:px-8 2xl:px-12 relative">
          <div className="max-w-4xl xl:max-w-5xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl xl:text-6xl 2xl:text-7xl font-bold tracking-tight mb-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
              Études Creative Strategist
            </h1>
            <p className="text-xl xl:text-2xl text-muted-foreground mb-8 leading-relaxed max-w-3xl mx-auto">
              Positionnement, identité, packaging et assets Amazon.
            </p>
            
            {/* Scroll indicator */}
            <div className="flex flex-col items-center mt-12 lg:mt-16">
              <p className="text-sm text-muted-foreground mb-3">Découvrez nos projets créatifs</p>
              <div className="w-6 h-10 border-2 border-primary/30 rounded-full flex justify-center">
                <div className="w-1 h-3 bg-primary rounded-full mt-2 animate-bounce"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Cards Section */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
            {cases.map((caseItem, index) => (
              <Card 
                key={index} 
                className="p-6 border-border bg-card hover:bg-card/80 transition-colors duration-200 cursor-pointer"
                onClick={() => navigate(caseItem.href)}
              >
                <Badge variant="outline" className="text-primary border-primary/30 bg-primary/10 mb-4">
                  {caseItem.badge}
                </Badge>
                <h3 className="text-xl font-bold mb-3">{caseItem.title}</h3>
                <p className="text-muted-foreground mb-6">{caseItem.subtitle}</p>
                <Button variant="outline" className="w-full">
                  Voir l'étude
                </Button>
              </Card>
            ))}
          </div>
        </div>
      </section>
      </div>
    </>
  );
}